// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Le0B","image":"Header_image__2BGGL","name":"Header_name__2IXDk","info":"Header_info__3u9cF","infoRow":"Header_infoRow__1AdyT"};